module.exports = __webpack_public_path__ + "static/media/red-brick.d0d609f9.jpg";